import {
  ChangeDetectionStrategy,
  Component,
  ViewEncapsulation,
} from '@angular/core';
import { DynamicWidgetDirective } from '@app/directives/dynamic-widget.directive';
import { NavListInput } from '@trackback/widgets';
import { MatListModule } from '@angular/material/list';
import { WidgetInputBaseComponent } from '@app/widgets/widget-input-base.component';
import parsed from '@app/utils/parsed';

@Component({
  selector: 'tb-nav-list',
  imports: [DynamicWidgetDirective, MatListModule],
  template: `
    <mat-nav-list [class]="parsedStyleClasses()" [disabled]="parsedDisabled()">
      @for (child of input().children; track $index) {
        <ng-container [dynamicWidget]="child" [context]="context()" />
      }
    </mat-nav-list>
  `,
  styles: `
    tb-nav-list {
      display: contents;
    }
  `,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export default class NavListComponent extends WidgetInputBaseComponent<NavListInput> {
  parsedStyleClasses = parsed(this.inputProp('styleClasses'), this.context);
  parsedDisabled = parsed(this.inputProp('disabled'), this.context);
}
